<template>
  <div>
    <h1>Nutzerübersicht</h1>
    <template v-if="users.length > 0 && projects.length > 0">
      Von:
      <datepicker :clear-button="true" @input="onDateSelected" v-model="from" class="text-box single-line" />

      Bis:
      <datepicker :clear-button="true" @input="onDateSelected" v-model="to" class="text-box single-line" />
      <div class="mt-2 mb-2">
        <a @click="onPreviousMonth" class="btn btn-info mr-2">Vorheriger Monat</a>
        <a @click="onCurrentMonth" class="btn btn-info">Aktueller Monat</a>
      </div>
      <div>
        Nur Nutzer zeigen, die aktiv sind oder nach dem {{ minimumLeaveDate.format("DD.MM.yyyy") }} gekündigt haben
        <input type="checkbox" v-model="showActiveUsers" autocomplete="off" />
      </div>

      <div class="row">
        <div class="col-md-4">
          <select v-model="userId" @change="onUserSelected" style="width:100%">
            <option :value="null" selected="selected">Alle</option>
            <option v-for="user in users" :key="user.id" :value="user.id"
              v-if="!showActiveUsers || (!user.leaveDate || user.leaveDate < minimumLeaveDate)">
              {{ user.name }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <multiselect v-model="selected" :options="projects" @input="onProjectSelected" label="title" track-by="id"
            :multiple="true" :group-select="true" :close-on-select="false" :clear-on-select="false"
            :preserve-search="true">
          </multiselect>
        </div>

      </div>

    </template>

    <br />
    <div v-if="hours.length > 0">
      <table class="table">
        <tr>
          <td>Datum</td>
          <td>Benutzer</td>
          <td>Von</td>
          <td>Bis</td>
          <td>Projekt</td>
          <td>Aufgabennummer</td>
          <td>Aufgabentitel</td>
          <td>Zahler</td>
          <td>Kommentar</td>
          <td>Status</td>
        </tr>
        <tr v-for="hour in hours" :key="hour.id">
          <td>{{ hour.from | formatDateDay }}</td>
          <td>{{ hour.user.name }}</td>
          <td>{{ hour.from | momentHour }}</td>
          <td>{{ hour.to | momentHour }}</td>
          <td>{{ getProject(hour.projectId) }}</td>
          <td>{{ hour.task }}</td>
          <td>{{ hour.taskTitle }}</td>
          <td>{{ hour.payer }}</td>
          <td>{{ hour.title }}</td>
          <td>{{ hour.comment }}</td>
          <td>{{ hour.status }}</td>
        </tr>
        <tr>
          <td> Gesamtstunden </td>
          <td>{{ totalHours }}</td>
        </tr>
      </table>

      <a @click="onCsvExport" class="btn btn-info mb-4 mt-2 ml-2">csv exportieren</a>
      <a v-if="adminAccess" @click="onDownloadHourOverlaps" class="btn btn-info mb-4 mt-2 ml-2">Stundenüberschneidungen herunterladen</a>

    </div>
    <div v-else>Keine Stunde gefunden.</div>
  </div>
</template>


<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>


<script>
import axios from "axios";
import moment from "moment";
import datepicker from "vuejs-datepicker";
import Multiselect from 'vue-multiselect'
import "../../assets/main.css";
import exportFromJSON from "export-from-json";
import { mapGetters, mapState } from "vuex";

export default {
  // OR register locally
  components: { datepicker, Multiselect },
  name: "hoursDateRange",
  data() {
    var from = moment().startOf("month").format("yyyy-MM-DD");
    var to = moment().format("yyyy-MM-DD");

    return {
      selected: null,
      users: [],
      projects: [],
      hours: [],
      hoursOriginal: [],
      from: from,
      to: to,
      userId: null,
      projectId: null,
      userProjects: [],
      showActiveUsers: true,
      minimumLeaveDate: moment().subtract(30, 'd'),

    };
  },
  methods: {
    getProject: function (projectId) {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id == projectId) {
          return this.projects[i].title;
        }
      }
    },

    getUser: function (userId) {
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].id == userId) {
          return this.users[i];
        }
      }
    },

    hourDifference: function (from, to) {
      var fromDate = moment(from);
      var toDate = moment(to); 
      var duration = moment.duration(toDate.diff(fromDate));
      var hours = duration.asHours();
      // console.log(fromDate + " " + toDate + " : " + hours);
      return hours.toFixed(2).replace(".", ",");
    },

    fetchHours: function () {
      this.hours = [];

      var url = process.env.VUE_APP_API_PATH +
        "hours/GetByUserDateRange" +
        "?from=" +
        this.from +
        "&to=" +
        this.to;

      if (this.userId != null && this.userId != "null") {
        url += "&userId=" + this.userId;
      }

      if (this.projectId != null && this.projectId != "null") {
        url += "&projectId=" + this.projectId;
      }

      axios({
        method: "GET",
        url: url
      }).then(
        (result) => {
          this.hoursOriginal = result.data;
          this.onProjectSelected();
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },

    onUserSelected: function () {
      if (this.userId != null) {
        var user = this.getUser(this.userId);
        console.log("user entry date", user.entryDate);
        this.from = moment(user.entryDate).format("yyyy-MM-DD");
      }

      this.fetchHours();
    },

    onProjectSelected: function () {
      if (this.selected) {
        this.hours = this.hoursOriginal.filter(item => this.selected.some(e => e.id === item.projectId))
      } else {
        this.hours = this.hoursOriginal;
      }
    },

    onDateSelected: function () {
      this.from = moment(this.from).format("yyyy-MM-DD");
      this.to = moment(this.to).format("yyyy-MM-DD");
      this.fetchHours();
    },

    onPreviousMonth: function () {
      this.from = moment(this.from).subtract(1, "month").format("yyyy-MM-DD");
      this.to = moment(this.to).subtract(1, "month").format("yyyy-MM-DD");
      this.fetchHours();
    },

    onCurrentMonth: function () {
      this.from = moment().startOf("month").format("yyyy-MM-DD");
      this.to = moment().format("yyyy-MM-DD");
      this.fetchHours();
    },
    onDownloadHourOverlaps: function () {
      axios.get(process.env.VUE_APP_API_PATH + 'hours/downloadOverlappingHours', { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'OverlappingHours.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
        });
    },
    onCsvExport: function () {

      const data = this.hours.map(hour => ({
        Datum: moment(hour.from).format("YYYY/MM/DD"),
        Benutzer: hour.user.name,
        Stunden: this.hourDifference(hour.from, hour.to),
        Projekt: this.getProject(hour.projectId),
        Aufgabennummer: hour.task,
        Aufgabentitel: hour.taskTitle,
        Zahler: hour.payer,
        Kommentar: hour.comment,
        Status: hour.status,
      }))

      const fileName = "Stundenschreibung" + "_" + "_" + this.from + "_" + this.to;
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({ data, fileName, exportType });
      }
  },

  computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        adminAccess: state => state.user.profile.adminAccess,
      }),
    totalHours() {
      var hoursSum = 0

      this.hours.map(function (value, key) {
        var startTime = moment(value.from);
        var endTime = moment(value.to);
        var duration = moment.duration(endTime.diff(startTime));
        hoursSum = hoursSum + duration.asHours();
      });

      return hoursSum;
    }
  },
  mounted() {
    axios({
      method: "GET",
      url: process.env.VUE_APP_API_PATH + "projects/GetAllProjects",
    }).then(
      (result) => {
        this.projects = result.data;
      },
      (error) => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      }
    );

    axios({
      method: "GET",
      url: process.env.VUE_APP_API_PATH + "user/get",
    }).then(
      (result) => {
        this.users = result.data;
      },
      (error) => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      }
    );

    this.userId = "null";
    if (this.$route.query.userId) {
      this.userId = this.$route.query.userId;
    }

    this.projectId = "null";
    if (this.$route.query.projectId) {
      this.projectId = this.$route.query.projectId;
    }

    if (this.$route.query.from != null) {
      this.from = this.$route.query.from;
    } else {
      this.from = moment().subtract(1, "week").format("yyyy-MM-DD");
    }

    if (this.$route.query.to != null) {
      this.to = this.$route.query.to;
    } else {
      this.to = moment().format("yyyy-MM-DD");
    }

    this.fetchHours();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
